import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Globe3 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zM5 15.8a8.42 8.42 0 002 .27 5 5 0 003.14-1c1.71-1.34 1.71-3.06 1.71-4.44a4.76 4.76 0 01.37-2.34 2.86 2.86 0 011.12-.91 9.75 9.75 0 00.92-.61 4.55 4.55 0 001.4-1.87A8 8 0 0119 8.12c-1.43.2-3.46.67-3.86 2.53A7 7 0 0015 12a2.93 2.93 0 01-.29 1.47l-.1.17c-.65 1.08-1.38 2.31-.39 4 .12.21.25.41.38.61a2.29 2.29 0 01.52 1.08A7.89 7.89 0 0112 20a8 8 0 01-7-4.2z",
    "data-name": "globe-3"
  })));
});
Globe3.displayName = 'Globe3';
export var Globe3Dimensions = {
  height: 24,
  width: 24
};